import React from "react";
import { isLoading } from "../Loading";
import { AppState } from "../system/AppState";

const usePatientsState = (appState: AppState) => {
  const [state, setState] = React.useState(appState.appPatientsState);

  React.useEffect(() => {
    const patientsUpdateBinding = appState.onPatientsUpdated.register(() => {
      if (!isLoading(appState.appPatientsState)) {
        setState(appState.appPatientsState);
      }
    });

    return () => patientsUpdateBinding.unregister();
  }, [appState]);

  return state;
};

export default usePatientsState;
